<template>
  <div class="customerservicereclamationsearch">
    <Dialog v-bind:visible="dialogOpen" :closable="false" modal :draggable="false"
    header="Einen Eintrag speichern" class="cua-modal" style="max-width: 30rem;">
    <span class="cua-modal-text">Speichere einen Eintrag.</span>
    <div class="cua-modal-inputs">
      <br>
      <FloatLabel>
  <AutoComplete
    id="createdby"
    v-model="createdby"
    :suggestions="createdbySuggestions"
    @complete="searchWorkers"
    class="cua-modal-btn"
    inputClass="w-full"
    dropdown
  />
  <label for="article">Ersteller</label>
</FloatLabel>
      <br>
      <FloatLabel>
        <InputText id="date" type="text" v-model="date" class="cua-modal-btn"></InputText>
        <label for="date">Auftrittsdatum</label>
      </FloatLabel>
      <br>
      <FloatLabel v-if="selectedEntry">
  <InputText id="completeddate" :disabled="selectedEntry.reklaausgang == 'Nachlieferung' || selectedEntry.accounting_action !== null" type="text" v-model="completeddate" class="cua-modal-btn"></InputText>
  <label for="completeddate">ABG-Datum</label>
</FloatLabel>
<br v-if="selectedEntry">
<FloatLabel>
  <AutoComplete
    id="supplier"
    v-model="supplier"
    :suggestions="supplierSuggestions"
    @complete="searchSuppliers"
    class="cua-modal-btn"
    inputClass="w-full"
    dropdown
  />
  <label for="supplier">Lieferant</label>
</FloatLabel>

      <br>
      <FloatLabel>
        <InputText id="order" type="text" v-model="order" class="cua-modal-btn"></InputText>
        <label for="order">Bestellnummer</label>
      </FloatLabel>
      <br>
      <FloatLabel>
  <AutoComplete
    id="article"
    v-model="article"
    :suggestions="articleSuggestions"
    @complete="searchArticles"
    class="cua-modal-btn"
    inputClass="w-full"
    dropdown
  />
  <label for="article">Artikelnummer</label>
</FloatLabel>

      <br>
      <FloatLabel>
        <Dropdown id="reason" v-model="reason" :options="reasonOptions" class="cua-modal-btn"></Dropdown>
        <label for="reason">Reklamationsgrund</label>
      </FloatLabel>
      <br>
      <FloatLabel>
        <InputText id="should" type="text" v-model="should" class="cua-modal-btn"></InputText>
        <label for="should">SOLL-Menge</label>
      </FloatLabel>
      <br>
      <FloatLabel>
        <InputText id="is" type="text" v-model="is" class="cua-modal-btn"></InputText>
        <label for="is">IST-Menge</label>
      </FloatLabel>
      <br>
      <FloatLabel>
        <InputText id="comment" type="text" v-model="comment" class="cua-modal-btn"></InputText>
        <label for="comment">Kommentar</label>
      </FloatLabel>
      <br>
      <FloatLabel v-if="selectedEntry">
  <Dropdown id="reklaausgang" v-model="reklaausgang" :options="reklaausgangOptions" class="cua-modal-btn"></Dropdown>
  <label for="reklaausgang">Rekla-Ausgang</label>
</FloatLabel>
<br v-if="selectedEntry">

<FloatLabel v-if="showaccounting_actionDropdown">
  <Dropdown id="accounting_action" v-model="accounting_action" :options="accounting_actionOptions" class="cua-modal-btn"></Dropdown>
  <label for="accounting_action">Buchhaltung</label>
</FloatLabel>
<br>
<FileUpload
  v-if="showaccounting_actionDropdown && selectedEntry"
  name="file"
  :url="`${configURL}/api/customerservice/claims/uploadCreditNote/${selectedEntry.id}`"
  :auto="true"
  :customUpload="false"
  accept="application/pdf"
  :maxFileSize="5000000"
  :withCredentials="true"
  @before-send="setUploadHeaders"
  @upload="onCreditNoteUpload"
>
  <template #empty>
    <span>Gutschrift/Rechnung (als PDF) Hier hinziehen.</span>
  </template>
</FileUpload>

<br v-if="showaccounting_actionDropdown">
<Panel
  v-if="hasAttachment"
  header="Anhang"
  class="mt-4"
  toggleable
>
  <p>
    <a
      :href="selectedEntry?.attachment"
      target="_blank"
      style="color: #42a5f5; text-decoration: underline;"
    >
      Anhang anzeigen (PDF öffnen)
    </a>
  </p>
</Panel>

<br v-if="hasAttachment">
    </div>
    <div class="cua-modal-btns">
      <Button class="cua-modal-btn" :loading="loading" icon="fa-solid fa-check" @click="createNewEntry"
        severity="success" label="Eintrag speichern"></Button>
      <Button class="cua-modal-btn" :disabled="loading" on="fa-solid fa-cancel" @click="dialogOpen = false" severity="danger" text
        outlined label="Abbrechen"></Button>
        <Button v-if="selectedEntry && authStore.hasUserPermission('customerservice.delete')" class="cua-modal-btn" :disabled="loading" on="fa-solid fa-cancel" @click="deleteEntry" severity="danger" text
        outlined label="Löschen"></Button>

    </div>
  </Dialog>
    <h2 class="customerservicereclamationsearch-header fadein">Reklamationssuche</h2>
    <div class="customerservicereclamationsearch-subtitle fadein d100ms">
      Finde Daten über Kundenservicereklamation heraus
    </div>
    <div class="customerservicereclamationsearch-card fadein d200ms">
      <ContextMenu ref="contextMenu" :model="contextMenuItems" />
      <Button
  v-if="claimFilterId"
  icon="pi pi-arrow-left"
  label="Zurück"
  class="mb-3"
  @click="resetClaimFilter"
/>

      <DataTable
  class="customerservicereclamationsearch-card-tabl"
  :size="size"
  :value="customerservicereclamationsearch"
  stripedRows
  paginator
  :rows="10"
  :loading="loading"
  v-model:filters="filters"
  :rowsPerPageOptions="[10, 25, 50, 100, 200]"
  :globalFilterFields="['supplier', 'order', 'article']"
  filterDisplay="menu"
  dataKey="id"
  :rowClass="rowClass" 
  @row-click="editEntry"
  @row-contextmenu="onRowRightClick"

>

        <template #empty> Es wurden keine Einträge gefunden. </template>
        <template #loading> Einträge werden geladen. Bitte warten. </template>

        <Column field="createdby" header="ERSTELLT VON"></Column>
        <Column field="date" header="AUFTRITTS DATUM"></Column>
        <Column field="completeddate" header="ABG DATUM"></Column>
        
        <Column field="supplier" header="LIEFERANT">
          <template #filter="{ filterModel, filterCallback }">
            <InputText 
              v-model="filters.supplier.value" 
              @input="filterCallback()" 
              class="customerservicereclamationsearch-filter-row"
              type="text" 
              placeholder="Nach LIEFERANT suchen"
            />
          </template>
        </Column>

        <Column field="order" header="BESTELLUNG">
          <template #filter="{ filterModel, filterCallback }">
            <InputText 
              v-model="filters.order.value" 
              @input="filterCallback()" 
              class="customerservicereclamationsearch-filter-row"
              type="text" 
              placeholder="Nach BESTELLUNG suchen"
            />
          </template>
        </Column>

        <Column field="article" header="ART. NR.">
          <template #filter="{ filterModel, filterCallback }">
            <InputText 
              v-model="filters.article.value" 
              @input="filterCallback()" 
              class="customerservicereclamationsearch-filter-row"
              type="text" 
              placeholder="Nach ARTIKEL suchen"
            />
          </template>
        </Column>
    
        <Column field="reason" header="GRUND">
          <template #body="{ data }">
            <span :class="getReasonClass(data.reason)">
              {{ data.reason }}
            </span>
          </template>
        </Column>
        
        <Column field="should" header="SOLL"></Column>
        <Column field="is" header="IST"></Column>
        <Column field="reklaausgang" header="REKLA-AUSGANG">
  <template #body="{ data }">
    <span :class="getReklaausgangClass(data.reklaausgang)">
      {{ data.reklaausgang }}
    </span>
  </template>
</Column>

        <Column field="accounting_action" header="BUCHHALTUNG"></Column>
        <Column field="comment" header="KOMMENTAR"></Column>
      </DataTable>

      <Button 
        style="margin-top: 1rem"
        @click="dialogOpen = true"
        :disabled="!authStore.hasUserPermission('customerservice.create')" 
        outlined 
        text 
        label="Eintrag Erstellen"
        severity="success" 
        icon="fa-solid fa-plus"
      ></Button>
    </div>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import { FilterMatchMode } from "primevue/api";
import axios from "axios";
import { getAuth } from "firebase/auth";
import SelectButton from "primevue/selectbutton";
import Button from "primevue/button";
import { config } from "../../../assets/config.js";
import { useAuthStore } from "@/stores/auth.js";
import Dialog from 'primevue/dialog'
import FloatLabel from "primevue/floatlabel"
import InputSwitch from 'primevue/inputswitch'
import Dropdown from 'primevue/dropdown'
import AutoComplete from 'primevue/autocomplete';
import ContextMenu from 'primevue/contextmenu';
import { useRoute, useRouter } from 'vue-router';
import FileUpload from "primevue/fileupload";
import Panel from "primevue/panel";

export default {
  components: {
    DataTable,
    Column,
    InputText,
    Button,
    SelectButton,
    Dialog,
    FloatLabel,
    InputSwitch,
    Dropdown,
    AutoComplete,
    ContextMenu,
    FileUpload,
    Panel
  },

  data() {
    return {
      authStore: useAuthStore(),
      customerservicereclamationsearch: [],
      filters: {
        supplier: { value: "", matchMode: FilterMatchMode.CONTAINS },
        order: { value: "", matchMode: FilterMatchMode.CONTAINS },
        article: { value: "", matchMode: FilterMatchMode.CONTAINS },
      },
      loading: true,
      dialogOpen: false,
      size: "small",
      sizeOptions: [
        { label: "Klein", value: "small" },
        { label: "Normal", value: "normal" },
        { label: "Groß", value: "large" },
      ],
      date: null,
      createdby: null,
      supplier: null,
      order: null,
      article: null,
      reason: null,
      should: null,
      is: null,
      configURL: config.api_url,
      comment: null,
      displayName: null,
      selectedEntry: null,
      uploadToken: null,
  completeddate: null,
  reklaausgang: null,
  accounting_action: null,
  showaccounting_actionDropdown: false,
  reklaausgangOptions: [
//    "Zurückgeschickt",
//    "Outlet",
//    "Eingelagert",
    "Nachlieferung",
    "Ersatzlieferung",
//    "Keine Antwort -> Kommentar",
    "Andere... -> Kommentar",
    "Buchhaltung"
  ],
  reasonOptions: [
//    "Mengendifferenz",
    "Beschädigt",
//    "Nicht geliefert",
//    "Falsch geliefert",
//    "Qualitätsdifferenz",
//    "Backorderüberschreitung",
    "Andere... -> Kommentar",
  ],
  accounting_actionOptions: ["Gutschrift"],
  contextMenuItems: [],
contextEntry: null,
supplierSuggestions: [],
articleSuggestions: [],
createdbySuggestions: [],
claimFilterId: null,

    };
  },
  computed: {
  hasAttachment() {
    return this.selectedEntry?.attachment != null;
  }
},

  methods: {
    setUploadHeaders(event) {
  if (this.uploadToken) {
    try {
      event.xhr.setRequestHeader("Authorization", this.uploadToken);
    } catch (e) {
      console.error("❌ Failed to set upload header:", e);
    }
  } else {
    console.error("❌ No token available to set header.");
  }
},
async handleManualUpload(event) {
  const file = event.files[0];
  const formData = new FormData();
  formData.append("file", file);

  try {
    const token = await getAuth().currentUser.getIdToken();

    await fetch(`${this.configURL}/api/customerservice/claims/uploadCreditNote/${this.selectedEntry.id}`, {
      method: 'POST',
      headers: {
        Authorization: token
      },
      body: formData
    });

    this.$toast.add({
      severity: 'success',
      summary: 'Datei hochgeladen',
      detail: 'Die Gutschrift wurde erfolgreich hochgeladen.',
      life: 4000
    });
  } catch (error) {
    console.error("❌ Upload fehlgeschlagen:", error);
    this.$toast.add({
      severity: 'error',
      summary: 'Fehler',
      detail: 'Die Datei konnte nicht hochgeladen werden.',
      life: 4000
    });
  }
},
onCreditNoteUpload(event) {
  this.$toast.add({
    severity: 'success',
    summary: 'Datei hochgeladen',
    detail: 'Die Gutschrift wurde erfolgreich hochgeladen.',
    life: 4000
  });
},
onRowRightClick(event) {
  const now = new Date().getTime();
  const timeSinceLastClick = now - this.lastRightClickTime;

  if (timeSinceLastClick < 500) {
    // Doppelter Rechtsklick → Browser-Kontextmenü zulassen
    this.lastRightClickTime = 0;
  } else {
    this.lastRightClickTime = now;
    return;
  }

  // Normales Verhalten → eigenes Menü
  event.originalEvent.preventDefault();
  this.lastRightClickTime = now;

  this.contextEntry = event.data;

  const id = this.contextEntry.id;
  const base = window.location.origin;

  const csLink = `${base}/customerservice/claims?claim=${id}`;
  const accLink = `${base}/accounting/customerservice/claims?claim=${id}`;
  const nlLink = `${base}/warehouse/followupdeliveries?delivery=${id}`;

  switch (this.contextEntry.reklaausgang) {
    case "Nachlieferung":
      this.contextMenuItems = [
        {
          label: "Kopiere Nachlieferungs-Link",
          icon: "pi pi-copy",
          command: () => copyToClipboard(nlLink, "Nachlieferungs-Link"),
        },
      ];
      break;
    case "Buchhaltung":
      this.contextMenuItems = [
        {
          label: "Kopiere Buchhaltungs-Link",
          icon: "pi pi-copy",
          command: () => copyToClipboard(accLink, "Buchhaltungs-Link"),
        },
        {
          label: "Kopiere Kundenservice-Link",
          icon: "pi pi-copy",
          command: () => copyToClipboard(csLink, "Kundenservice-Link"),
        },
      ];
      break;
    case "Andere... -> Kommentar":
      this.contextMenuItems = [
        {
          label: "Kopiere Buchhaltungs-Link",
          icon: "pi pi-copy",
          command: () => copyToClipboard(accLink, "Buchhaltungs-Link"),
        },
        {
          label: "Kopiere Nachlieferungs-Link",
          icon: "pi pi-copy",
          command: () => copyToClipboard(nlLink, "Nachlieferungs-Link"),
        },
        {
          label: "Kopiere Kundenservice-Link",
          icon: "pi pi-copy",
          command: () => copyToClipboard(csLink, "Kundenservice-Link"),
        },
      ];
      break;
    default:
      this.contextMenuItems = [
        {
          label: "Kopiere Kundenservice-Link",
          icon: "pi pi-copy",
          command: () => copyToClipboard(csLink, "Kundenservice-Link"),
        },
      ];
  }

  this.$refs.contextMenu.show(event.originalEvent);
},

copyToClipboard(url, label) {
  navigator.clipboard.writeText(url).then(() => {
    this.$toast.add({
      severity: "success",
      summary: "Kopiert",
      detail: `${label} kopiert!`,
      life: 3000
    });
  }).catch((err) => {
    console.error("❌ Kopieren fehlgeschlagen:", err);
    this.$toast.add({
      severity: "error",
      summary: "Fehler",
      detail: "Konnte den Link nicht kopieren.",
      life: 3000
    });
  });
},


async searchSuppliers(event) {
  try {
    const response = await axios.get(config.api_url + "/api/customerservice/suppliers", {
      headers: {
        Authorization: await getAuth().currentUser.getIdToken(),
      },
      params: { q: event.query }
    });
    this.supplierSuggestions = response.data;
  } catch (e) {
    console.error("❌ Supplier Autocomplete Fehler:", e);
  }
},

parseDate(dateStr) {
  if (!dateStr || typeof dateStr !== 'string' || !dateStr.includes('.')) return null;
  const parts = dateStr.split(".");
  return new Date(parts[2], parts[1] - 1, parts[0]);
},

formatDate(dateStr) {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  return date.toLocaleDateString("de-DE");
},

convertToISO(date) {
  if (!date || !(date instanceof Date)) return null;
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
},

async searchWorkers(event) {
  try {
    const response = await axios.get(config.api_url + "/api/warehouse/workers", {
      headers: {
        Authorization: await getAuth().currentUser.getIdToken(),
      },
      params: {
        q: event.query
      }
    });
    this.createdbySuggestions = response.data;
  } catch (e) {
    console.error("Workers autocomplete failed:", e);
  }
},


async searchArticles(event) {
  try {
    const response = await axios.get(config.api_url + "/api/customerservice/articles", {
      headers: {
        Authorization: await getAuth().currentUser.getIdToken(),
      },
      params: { q: event.query }
    });
    this.articleSuggestions = response.data;
  } catch (e) {
    console.error("❌ Article Autocomplete Fehler:", e);
  }
},


async fetchData() {
  try {
    const response = await axios.get(config.api_url + "/api/customerservice/claims/search", {
      headers: {
        Authorization: await getAuth().currentUser.getIdToken(),
      },
    });


    let entries = this.modifyData(response.data);

    if (this.claimFilterId) {
      entries = entries.filter(entry => entry.id === this.claimFilterId);
    }

    entries.sort((a, b) => {
  const dateA = this.parseDate(a.date);
  const dateB = this.parseDate(b.date);

  const completedDateA = a.completeddate && a.completeddate.trim() !== '' && a.completeddate !== ' ' 
    ? this.parseDate(a.completeddate)
    : null;

  const completedDateB = b.completeddate && b.completeddate.trim() !== '' && b.completeddate !== ' ' 
    ? this.parseDate(b.completeddate)
    : null;

  if (!completedDateA && completedDateB) return -1;
  if (completedDateA && !completedDateB) return 1;
  if (!completedDateA && !completedDateB) return dateB - dateA;

  return completedDateB - completedDateA;
});

    const tokenFetches = entries.map(async (entry) => {
  if (entry.attachment) {
    try {
      const res = await axios.get(`${config.api_url}/api/customerservice/reclamationsearch/getToken/${entry.id}`, {
        headers: {
          Authorization: await getAuth().currentUser.getIdToken()
        }
      });

      if (res.status === 200 && res.data.token) {
        entry.attachment = `${config.api_url}/customerservice/reclamationsearch/creditnote/${entry.id}.pdf/${res.data.token}`;
      }
    } catch (err) {
      console.warn(`❌ Could not fetch token for ID ${entry.id}:`, err.message);
      entry.attachment = null;
    }
  }
});

await Promise.all(tokenFetches);
this.customerservicereclamationsearch = entries;

  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    this.loading = false;
  }
},

resetClaimFilter() {
  this.claimFilterId = null;
  this.$router.push('/customerservice/claims');
  this.fetchData();
},



async editEntry(event) {
  this.selectedEntry = event.data;
  this.dialogOpen = true;

  this.date = this.selectedEntry.date;
  this.supplier = this.selectedEntry.supplier;
  this.order = this.selectedEntry.order;
  this.article = this.selectedEntry.article;
  this.reason = this.selectedEntry.reason;
  this.should = this.selectedEntry.should;
  this.is = this.selectedEntry.is;
  this.comment = this.selectedEntry.comment;
  this.attachment = this.selectedEntry.attachment ?? null;
  const rawCompletedDate = this.selectedEntry.completeddate;
  this.completeddate =
    typeof rawCompletedDate === 'string' &&
    rawCompletedDate.trim() !== '' &&
    rawCompletedDate !== ' '
      ? this.parseDate(rawCompletedDate)
      : null;
  this.reklaausgang = this.selectedEntry.reklaausgang;
  this.accounting_action = this.selectedEntry.accounting_action;
  this.createdby = this.selectedEntry.createdby

  this.showaccounting_actionDropdown = ["Buchhaltung", "Andere... -> Kommentar"].includes(this.reklaausgang);
  try {
    this.uploadToken = await getAuth().currentUser.getIdToken();
  } catch (e) {
    console.error("❌ Failed to get upload token:", e);
  }
},
rowClass(data) {
  const today = new Date();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(today.getDate() - 7);

  if (!data.completeddate && new Date(data.date) < oneWeekAgo) {
    return 'row-red'; 
  }
  return '';
},
getReasonClass(reason) {
  const colors = {
    "Beschädigt": "reason-red",
    "Lieferumfang Unvollständig": "reason-darkred",
//    "Nicht geliefert": "reason-lightred",
//    "Falsch geliefert": "reason-purple",
//    "Qualitätsdifferenz": "reason-blue",
//    "Backorderüberschreitung": "reason-teal",
    "Andere... -> Kommentar": "reason-white"
  };

  return colors[reason] || "";
},

getReklaausgangClass(reklaausgang) {
  const colors = {
//    "Zurückgeschickt": "rekla-green",
//    "Outlet": "rekla-purple",
//    "Eingelagert": "rekla-darkgreen",
    "Nachlieferung": "rekla-yellow",
    "Ersatzlieferung": "rekla-orange",
    "Buchhaltung": "rekla-orange",
//    "Keine Antwort -> Kommentar": "rekla-red",
    "Andere... -> Kommentar": "rekla-white"
  };

  return colors[reklaausgang] || "";
},

    modifyData(data) {
      return data.map((entry) => ({
        ...entry,
        date: this.formatDate(entry.date),
        completeddate: this.formatDate(entry.completeddate),
      }));
    },
    async createNewEntry() {

  this.loading = true;


  if (!this.date || !this.supplier || !this.order || !this.reason || !this.should == null || !this.createdby == null || !this.is == null) {
    this.$toast.add({
      severity: 'error',
      summary: 'Erstellung fehlgeschlagen',
      group: "tc",
      detail: 'Bitte fülle alle Pflichtfelder aus.',
      life: 5000
    });

    this.loading = false;
    return;
  }

  let userNameResponse;
  try {
    userNameResponse = await axios.get(config.api_url + '/api/user/getDisplayName', {
      headers: { Authorization: await getAuth().currentUser.getIdToken() }
    });

    if (userNameResponse.status === 200) {
      this.displayName = userNameResponse.data.displayname;
    }
  } catch (error) {
    console.error("❌ [ERROR] Failed to fetch display name:", error);
    return;
  }

  const payload = {
    createdby: this.createdby,
    date: this.date,
    supplier: this.supplier,
    order: this.order,
    article: this.article,
    reason: this.reason,
    should: this.should.toString(),
    is: this.is.toString(),
    comment: this.comment
  };

  if (this.selectedEntry) {
    payload.completeddate = 
    this.completeddate instanceof Date && !isNaN(this.completeddate)
      ? this.convertToISO(this.completeddate)
      : ' ';
    payload.reklaausgang = this.reklaausgang;

    if (["Buchhaltung", "Andere... -> Kommentar"].includes(this.reklaausgang)) {
      payload.accounting_action = this.accounting_action;
    }
  }

  try {
    let response;
    if (this.selectedEntry) {
      response = await axios.put(config.api_url + '/api/customerservice/claims/update/' + this.selectedEntry.id, payload, {
        headers: { Authorization: await getAuth().currentUser.getIdToken() }
      });
    } else {
      response = await axios.post(config.api_url + '/api/customerservice/claims/add', payload, {
        headers: { Authorization: await getAuth().currentUser.getIdToken() }
      });
    }

    if (response.status === 201 || response.status === 200) {
      this.$toast.add({
        severity: 'success',
        summary: 'Eintrag gespeichert',
        group: "tc",
        detail: 'Der Eintrag wurde erfolgreich gespeichert.',
        life: 5000
      });

      this.fetchData();
      this.close()
    }
  } catch (error) {
    console.error("❌ [ERROR] API request failed:", error);
    this.$toast.add({
      severity: 'error',
      summary: 'Fehler',
      group: "tc",
      detail: 'Fehler beim Speichern des Eintrags.',
      life: 5000
    });
  } finally {
    this.loading = false;
  }
},

async deleteEntry() {
  if(this.selectedEntry === null) {
    this.$toast.add({
      severity: 'error',
      summary: 'Fehler',
      group: "tc",
      detail: 'Es Ist Kein Eintrag Ausgewählt',
      life: 5000
    });
  }
  let response;
  response = await axios.delete(config.api_url + '/api/customerservice/claims/delete/' + this.selectedEntry.id, {
        headers: { Authorization: await getAuth().currentUser.getIdToken() }
      });

      if (response.status === 200) {
      this.$toast.add({
        severity: 'success',
        summary: 'Eintrag gelöscht',
        group: "tc",
        detail: 'Der Eintrag wurde erfolgreich gelöscht.',
        life: 5000
      });

      this.fetchData();
      this.close()
    }

},

close() {
  this.selectedEntry = null;
  this.date = null;
  this.supplier = null;
  this.order = null;
  this.incomegoodsnumber = null;
  this.article = null;
  this.reason = null;
  this.should = null;
  this.is = null;
  this.comment = null;
  this.attachment = null;
  this.completeddate = null;
  this.reklaausgang = null;
  this.accounting_action = null;
this.dialogOpen = false;
}
  },

  mounted() {
      const route = useRoute();
  const claimId = route.query.claim;
  if (claimId) {
    this.claimFilterId = parseInt(claimId);
  }
    this.fetchData();
  },
  watch: {
  reklaausgang(newVal) {
    this.showaccounting_actionDropdown = ["Buchhaltung", "Andere... -> Kommentar"].includes(newVal);
  }
}
};
</script>

<style lang="scss" scoped>
.customerservicereclamationsearch {
  &-filter-row {
    display: flex;
    align-items: flex-start;
    max-width: 15rem;
  }

  &-header {
    margin-bottom: 0;
  }

  &-subtitle {
    color: rgb(192, 192, 192);
  }

  &-card {
    margin-top: 2rem;
    border-radius: 1rem;
    padding: 1rem;
    background-color: var(--surface-0);
  }
}

/* 🔹 Modal Styling */
.cua-modal {
  padding: 1.5rem;
  background-color: var(--surface-800);
  border-radius: 0.75rem;
}

.cua-modal-text {
  font-size: 1.2rem;
  font-weight: bold;
  color: white;
  margin-bottom: 1rem;
  display: block;
}

/* 🔹 Fix FloatLabel Spacing */
.cua-modal-inputs FloatLabel {
  display: block;
  margin-bottom: 1.2rem; /* Ensures spacing between fields */
}

/* 🔹 Standard Button & Input Styles */
.cua-modal-btn {
  width: 100%;
  height: 2.5rem;
  font-size: 1rem;
  border-radius: 0.5rem;
}

/* 🔹 Fix Dropdown Size to Match Input Fields */
.p-dropdown {
  width: 100%;
  height: 2.5rem;
}

/* 🔹 Ensure Buttons Align Correctly */
.cua-modal-btns {
  display: flex;
  justify-content: space-between; /* Buttons appear side by side */
  gap: 1rem; /* Adds spacing between buttons */
  margin-top: 1rem;
}

/* 🔹 Hide Rekla-Ausgang & Buchhaltung on New Entry */
[v-cloak] {
  display: none;
}

/* 🔹 Red rows for outdated claims */
.row-red {
  background-color: #ffcccc !important; /* Light red background */
}

/* 🔹 Reason Colors */
.reason-red {
  background-color: #ff5733 !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-darkred {
  background-color: #d32f2f !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-lightred {
  background-color: #ff1744 !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-purple {
  background-color: #8e24aa !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-blue {
  background-color: #1976d2 !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-teal {
  background-color: #009688 !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-white {
  background-color: #ffffff !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

/* 🔹 Reklaausgang Colors */
.rekla-green {
  background-color: #b7e1a1 !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

.rekla-purple {
  background-color: #4a148c !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.rekla-darkgreen {
  background-color: #388e3c !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.rekla-yellow {
  background-color: #ffeb3b !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

.rekla-orange {
  background-color: #ff9800 !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

.rekla-red {
  background-color: #d32f2f !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.rekla-white {
  background-color: #ffffff !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

::v-deep(.p-datatable-striped .p-datatable-tbody > tr:nth-child(even)) {
  background-color: #464646 !important; // light grey
}
</style>
